



































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';

import {
  DataBus,
  DataTableRequest,
  ResponseCodeEnum,
  TireTypeEnum,
  InputError,
  Customer,
  TireStoringContract,
  TireStoringContractSeasonInfo,
  TireStoringInfo,
  EnumObject,
  TireBrand,
  TirePatternGroup,
  TirePattern,
  TireSize,
  TireWear,
  TireWidth,
  ContractPeriodEnum,
  TireWidthFee,
  Utils,
  ContractStatusEnum,
  RoleEnum,
  Location
} from '@/models';

import {
  agencyService,
  tireStoringContractService,
  tireBrandService,
  tirePatternGroupService,
  tireSizeService,
  tireWearService,
  tireWidthService,
  tireWidthFeeService,
  locationService,
  toastService
} from '@/services';

@Component
export default class TireRegisterInputInfo extends Vue {
  @Prop() public isEdit!: boolean;
  @Prop() public isReNew!: boolean;
  @Prop() public isSwitch!: boolean;
  @Prop() public tireContract!: TireStoringContract;
  @Prop() public tireContractList!: TireStoringContract[];

  private activeTabSummer: boolean | null = null;
  private activeTabWinter: boolean | null = null;
  private showTabSummer: boolean = true;
  private showTabWinter: boolean = true;
  private isSummerTabError: boolean = false;
  private isWinterTabError: boolean = false;
  private contractPeriodOptions: EnumObject[] = [];
  private numberOfTire: EnumObject[] = [];
  // private tireScratchOptions: EnumObject[] = [];
  // private tireIrregularWearOptions: EnumObject[] = [];
  private tireBrandOptions: TireBrand[] = [];
  private tirePatternGroupOptions: TirePatternGroup[] = [];
  private tirePatternOptions: TirePattern[] = [];
  private tireTypeOptions: EnumObject[] = [];
  private tireSizeOptions: TireSize[] = [];
  private tireWearOptions: TireWear[] = [];
  private tireWidthOptions: TireWidth[] = [];
  private tireConditionOptions: EnumObject[] = [];
  private tireHardnessOptions: EnumObject[] = [];
  private tireFeeList: TireWidthFee[] = [];

  private tireBrandDefaultOption: TireBrand = new TireBrand();

  private errors: InputError[] = [
    { field: 'period', isError: undefined, message: [] },
    { field: 'numberOfSummerTire', isError: undefined, message: [] },
    { field: 'numberOfWinterTire', isError: undefined, message: [] },
    { field: 'tireType', isError: undefined, message: [] },
    { field: 'wheelsSize', isError: undefined, message: [] },
    { field: 'wheelsBrand', isError: undefined, message: [] },
    { field: 'carManufacture', isError: undefined, message: [] },
    { field: 'carModel', isError: undefined, message: [] },
    { field: 'note', isError: undefined, message: [] },
    { field: 'seasonInfoExist', isError: undefined, message: [] },
    { field: 'summerSeasonInfo.tireBrand', isError: undefined, message: [] },
    { field: 'summerSeasonInfo.tireSize', isError: undefined, message: [] },
    { field: 'summerSeasonInfo.tireWear', isError: undefined, message: [] },
    { field: 'summerSeasonInfo.tireWidth', isError: undefined, message: [] },
    { field: 'summerSeasonInfo.tirePatternText', isError: undefined, message: [] },
    { field: 'winterSeasonInfo.tireBrand', isError: undefined, message: [] },
    { field: 'winterSeasonInfo.tireSize', isError: undefined, message: [] },
    { field: 'winterSeasonInfo.tireWear', isError: undefined, message: [] },
    { field: 'winterSeasonInfo.tireWidth', isError: undefined, message: [] },
    { field: 'winterSeasonInfo.tirePatternText', isError: undefined, message: [] },
    // { field: 'rackLocation', isError: undefined, message: [] },
    // { field: 'columnLocation', isError: undefined, message: [] },
    // { field: 'rowLocation', isError: undefined, message: [] },
    { field: 'number', isError: undefined, message: [] },
    { field: 'separateControlNumber', isError: undefined, message: [] },
    { field: 'memo', isError: undefined, message: [] },
    { field: 'storeManager', isError: undefined, message: [] },
    { field: 'summerSeasonInfo.wheelSize', isError: undefined, message: [] },
    { field: 'summerSeasonInfo.wheelBrand', isError: undefined, message: [] },
    { field: 'winterSeasonInfo.wheelSize', isError: undefined, message: [] },
    { field: 'winterSeasonInfo.wheelBrand', isError: undefined, message: [] },
  ];

  private getMsgErrorLocationNo(): InputError | [] {
    const erros = this.errors.find(
      (e: any) => e.field === 'rackLocation' && e.message.length > 0 
                || e.field === 'columnLocation' && e.message.length > 0
                || e.field === 'rowLocation' && e.message.length > 0
      );
    return erros || [];
  }

  get isAgency() {
    const currentUser = this.$store.state.user;
    return currentUser.role === RoleEnum.ROLE_AGENCY;
  }

  private created() {
    this.setDefaultTireContract();
    if (this.isEdit) {
      // get all PERIOD
      tireStoringContractService.getContractPeriod()
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          this.contractPeriodOptions = res.data.data;
        }
      });
    } else {
      // GET ONLY PERIOD in Manage company config
      tireStoringContractService.getContractPeriodByConfigCompany(this.tireContract.id || '')
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          this.contractPeriodOptions = res.data.data;
          if (!this.tireContract.id) {
            this.tireContract.period = this.contractPeriodOptions.length ? this.contractPeriodOptions[0].value : null;
          } else if (!this.contractPeriodOptions.some(x => x.value === this.tireContract.period)) {
            this.tireContract.period = undefined;
          }
          
        }
      });
    }

    tireStoringContractService.getNumberOfTire()
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          this.numberOfTire = res.data.data;
        }
      });
    tireStoringContractService.getTireType()
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          this.tireTypeOptions = res.data.data.map((option) => {
            if (option.text) {
              option.text = this.$t(option.text).toString();
            }
            return option;
          });
        }
      });
    tireStoringContractService.getTireCondition()
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          this.tireConditionOptions = res.data.data.map((option) => {
            if (option.text) {
              option.text = this.$t(option.text).toString();
            }
            return option;
          });
        }
      });
    tireStoringContractService.getTireHardness()
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          this.tireHardnessOptions = res.data.data.map((option) => {
            if (option.text) {
              option.text = this.$t(option.text).toString();
            }
            return option;
          });
        }
      });
    if (this.isEdit && this.tireContract.agency && this.tireContract.agency.id) {
      // If this is old contract, load price from the contract's agency
      tireWidthFeeService.findByAgency(this.tireContract.agency.id)
        .then((res) => {
          if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
            this.tireFeeList = res.data.data;
          }
        });
    } else if ((this.$store.state.user.role === RoleEnum.ROLE_ADMIN || this.$store.state.user.role === RoleEnum.ROLE_COMPANY_ADMIN) && this.tireContract.agency && this.tireContract.agency.id) {
      tireWidthFeeService.findByAgency(this.tireContract.agency.id)
        .then((res) => {
          if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
            this.tireFeeList = res.data.data;
          }
        });
    } else {
      // If this is new contract, load price from the current agency
      agencyService.getCurrentAgency()
        .then((res) => {
          if (res.data.code !== ResponseCodeEnum.CODE_SUCCESS || !res.data.data || !res.data.data.id) {
            return Promise.reject('agency_not_found');         
          }
          return tireWidthFeeService.findByAgency(res.data.data.id);
        })
        .then((res) => {
          if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
            this.tireFeeList = res.data.data;
          }
        })
        .catch((err) => {
          if (err === 'agency_not_found') {
            // TODO
          }
        });
      }
    if (this.isSwitch) {
      this.tireContract.tireType = this.tireContract.tireType === TireTypeEnum.SUMMER
        ? TireTypeEnum.WINTER
        : TireTypeEnum.SUMMER;
    }
    if ((this.isSwitch || this.isReNew) && this.tireContract) {
      if (this.tireContract.tireType === TireTypeEnum.SUMMER) {
        this.activeTabSummer = true;
      } else {
        this.activeTabWinter = true;
      }
    }
    this.loadTireOptions();
    this.loadTireSeasonInfo();
    this.setDefaultTireBrand();
  }


  private setDefaultTireContract() {
    this.tireContract.numberOfSummerTire = 3;
    this.tireContract.numberOfWinterTire = 3;
  }

  private loadTireSeasonInfo() { 
    // Create default data for tire info
    if (!this.tireContract.summerSeasonInfo) {
      this.tireContract.summerSeasonInfo = new TireStoringContractSeasonInfo({
        tireType: TireTypeEnum.SUMMER,
        tires: [
          new TireStoringInfo({ no: 1, type: TireTypeEnum.SUMMER }),
          new TireStoringInfo({ no: 2, type: TireTypeEnum.SUMMER }),
          new TireStoringInfo({ no: 3, type: TireTypeEnum.SUMMER }),
          new TireStoringInfo({ no: 4, type: TireTypeEnum.SUMMER }),
        ],
      });
    }
    if (!this.tireContract.winterSeasonInfo) {
      this.tireContract.winterSeasonInfo = new TireStoringContractSeasonInfo({
        tireType: TireTypeEnum.WINTER,
        tires: [
          new TireStoringInfo({ no: 1, type: TireTypeEnum.WINTER }),
          new TireStoringInfo({ no: 2, type: TireTypeEnum.WINTER }),
          new TireStoringInfo({ no: 3, type: TireTypeEnum.WINTER }),
          new TireStoringInfo({ no: 4, type: TireTypeEnum.WINTER }),
        ],
      });
    }
    if (this.tireContract.period === ContractPeriodEnum.SIX_MONTH) {
      this.showTabSummer = this.tireContract.tireType === TireTypeEnum.SUMMER;
      this.showTabWinter = this.tireContract.tireType === TireTypeEnum.WINTER;
    } else {
      this.showTabSummer = true;
      this.showTabWinter = true;
    }
    // Load summer season tire
    if (this.tireContract.summerSeasonInfo && this.tireContract.summerSeasonInfo.tires) {
      this.tireContract.summerSeasonInfo.tires.forEach((tire, index) => {
        // if (!tire.size && this.tireContract.summerSeasonInfo && this.tireContract.summerSeasonInfo.tireSize) {
        //   tire.size = this.tireContract.summerSeasonInfo.tireSize;
        // }
        this.errors.push({ field: 'summerSeasonInfo.tires[' + index + '].groove', isError: undefined, message: [] });
        this.errors.push({ field: 'summerSeasonInfo.tires[' + index + '].tireBrand', isError: undefined, message: [] }); 
        this.errors.push({ field: 'summerSeasonInfo.tires[' + index + '].size', isError: undefined, message: [] });
        this.errors.push({ field: 'summerSeasonInfo.tires[' + index + '].wear', isError: undefined, message: [] });
        this.errors.push({ field: 'summerSeasonInfo.tires[' + index + '].width', isError: undefined, message: [] });
        this.errors.push({ field: 'summerSeasonInfo.tires[' + index + '].irregularWear', isError: undefined, message: [] });
        this.errors.push({ field: 'summerSeasonInfo.tires[' + index + '].crack', isError: undefined, message: [] });
        this.errors.push({ field: 'summerSeasonInfo.tires[' + index + '].scratchDeformation', isError: undefined, message: [] });
        this.errors.push({ field: 'summerSeasonInfo.tires[' + index + '].hardness', isError: undefined, message: [] });
      });
    }
    // Load winter season tire
    if (this.tireContract.winterSeasonInfo && this.tireContract.winterSeasonInfo.tires) {
      this.tireContract.winterSeasonInfo.tires.forEach((tire, index) => {
        // if (!tire.size && this.tireContract.winterSeasonInfo && this.tireContract.winterSeasonInfo.tireSize) {
        //   tire.size = this.tireContract.winterSeasonInfo.tireSize;
        // }
        this.errors.push({ field: 'winterSeasonInfo.tires[' + index + '].groove', isError: undefined, message: [] });
        this.errors.push({ field: 'winterSeasonInfo.tires[' + index + '].tireBrand', isError: undefined, message: [] }); 
        this.errors.push({ field: 'winterSeasonInfo.tires[' + index + '].size', isError: undefined, message: [] });
        this.errors.push({ field: 'winterSeasonInfo.tires[' + index + '].wear', isError: undefined, message: [] });
        this.errors.push({ field: 'winterSeasonInfo.tires[' + index + '].width', isError: undefined, message: [] });
        this.errors.push({ field: 'winterSeasonInfo.tires[' + index + '].irregularWear', isError: undefined, message: [] });
        this.errors.push({ field: 'winterSeasonInfo.tires[' + index + '].crack', isError: undefined, message: [] });
        this.errors.push({ field: 'winterSeasonInfo.tires[' + index + '].scratchDeformation', isError: undefined, message: [] });
        this.errors.push({ field: 'winterSeasonInfo.tires[' + index + '].hardness', isError: undefined, message: [] });
      });
    }
  }

  private loadTireOptions() {
    tireBrandService.getAll()
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.items) {
          this.tireBrandOptions = res.data.items;
        }
      });
    tirePatternGroupService.getAll()
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.items) {
          this.tirePatternGroupOptions = res.data.items;
        }
      });
    tireSizeService.getAll()
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.items) {
          this.tireSizeOptions = res.data.items;
        }
      });
    tireWearService.getAll()
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.items) {
          this.tireWearOptions = res.data.items;
        }
      });
    tireWidthService.getAll()
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.items) {
          this.tireWidthOptions = res.data.items;
        }
      });
  }

  private searchTirePattern(filter: string) {
    return this.tirePatternOptions.filter((option) => {
      if (option.name) {
        return option.name.search(filter) >= 0;
      }
      return false;
    });
  }

  private addTire(isSummer: boolean) {
    let seasonInfo = isSummer ? this.tireContract.summerSeasonInfo : this.tireContract.winterSeasonInfo;
    if (seasonInfo && seasonInfo.tires && seasonInfo.tires.length < 6) {
      const index = seasonInfo.tires.length;
      this.errors.push({ field: isSummer 
        ? 'summerSeasonInfo.tires[' + index + '].groove' 
        : 'winterSeasonInfo.tires[' + index + '].groove', isError: undefined, message: [] });
      this.errors.push({ field: isSummer 
        ? 'summerSeasonInfo.tires[' + index + '].tireBrand' 
        : 'winterSeasonInfo.tires[' + index + '].tireBrand', isError: undefined, message: [] }); 
      this.errors.push({ field: isSummer 
        ? 'summerSeasonInfo.tires[' + index + '].size' 
        : 'winterSeasonInfo.tires[' + index + '].size', isError: undefined, message: [] });
      this.errors.push({ field: isSummer 
        ? 'summerSeasonInfo.tires[' + index + '].wear' 
        : 'winterSeasonInfo.tires[' + index + '].wear', isError: undefined, message: [] });
      this.errors.push({ field: isSummer 
        ? 'summerSeasonInfo.tires[' + index + '].width' 
        : 'winterSeasonInfo.tires[' + index + '].width', isError: undefined, message: [] });
      this.errors.push({ field: isSummer 
        ? 'summerSeasonInfo.tires[' + index + '].irregularWear' 
        : 'winterSeasonInfo.tires[' + index + '].irregularWear', isError: undefined, message: [] });
      this.errors.push({ field: isSummer 
        ? 'summerSeasonInfo.tires[' + index + '].crack' 
        : 'winterSeasonInfo.tires[' + index + '].crack', isError: undefined, message: [] });
      this.errors.push({ field: isSummer 
        ? 'summerSeasonInfo.tires[' + index + '].scratchDeformation' 
        : 'winterSeasonInfo.tires[' + index + '].scratchDeformation', isError: undefined, message: [] });
      this.errors.push({ field: isSummer 
        ? 'summerSeasonInfo.tires[' + index + '].hardness' 
        : 'winterSeasonInfo.tires[' + index + '].hardness', isError: undefined, message: [] });
      seasonInfo.tires.push(new TireStoringInfo({
        seasonInfoId: seasonInfo.id,
        type: isSummer ? TireTypeEnum.SUMMER : TireTypeEnum.WINTER,
        no: index + 1,
        imageUrl: '',
      }));     
    }
  }

  private changeNumberOfWinterTire(value: number) {
    let seasonInfo = this.tireContract.winterSeasonInfo;
    if(seasonInfo && seasonInfo.tires.length > 0) {
      let length = seasonInfo.tires.length;
      for(let i = length; i >= 0; i--) {
        this.removeTire(false, i);
      }  
    }
    for(let i = 0; i <= value; i++) {
      this.addTire(false);
    } 
  }

  private changeNumberOfSummerTire(value: number) {
    let seasonInfo = this.tireContract.summerSeasonInfo;
    if(seasonInfo && seasonInfo.tires.length > 0) {
      let length = seasonInfo.tires.length;
      for(let i = length; i >= 0; i--) {
        this.removeTire(true, i);
      }
    }
    for(let i = 0; i <= value; i++) {
      this.addTire(true);
    } 
  }

  private copyTire(isSummer: boolean) {
    let seasonInfo = isSummer ? this.tireContract.summerSeasonInfo : this.tireContract.winterSeasonInfo;
    if (!seasonInfo) {
      return;
    }
    const firstTire = seasonInfo.tires[0];
    seasonInfo.tires.forEach((tire) => {
      tire.tireBrand = firstTire.tireBrand;
      tire.groove = firstTire.groove;
      tire.size = firstTire.size;
      tire.wear = firstTire.wear;
      tire.width = firstTire.width;
      tire.irregularWear = firstTire.irregularWear;
      tire.crack = firstTire.crack;
      tire.scratchDeformation = firstTire.scratchDeformation;
      tire.hardness = firstTire.hardness;
    });
  }

  private removeTire(isSummer: boolean, tireIndex: number) {
    let seasonInfo = isSummer ? this.tireContract.summerSeasonInfo : this.tireContract.winterSeasonInfo;
    if (seasonInfo && seasonInfo.tires) {
      seasonInfo.tires.splice(tireIndex, 1); 
      const grooveIndex = this.errors.findIndex((error) => error.field === (isSummer 
        ? 'summerSeasonInfo.tires[' + tireIndex + '].groove' 
        : 'winterSeasonInfo.tires[' + tireIndex + '].groove'));
      if (grooveIndex > -1) { this.errors.splice(grooveIndex, 1); }
      const tireBrandIndex = this.errors.findIndex((error) => error.field === (isSummer 
        ? 'summerSeasonInfo.tires[' + tireIndex + '].tireBrand' 
        : 'winterSeasonInfo.tires[' + tireIndex + '].tireBrand'));
      if (tireBrandIndex > -1) { this.errors.splice(tireBrandIndex, 1); }
      const sizeIndex = this.errors.findIndex((error) => error.field === (isSummer 
        ? 'summerSeasonInfo.tires[' + tireIndex + '].size' 
        : 'winterSeasonInfo.tires[' + tireIndex + '].size'));
      if (sizeIndex > -1) { this.errors.splice(sizeIndex, 1); }
      const wearIndex = this.errors.findIndex((error) => error.field === (isSummer 
        ? 'summerSeasonInfo.tires[' + tireIndex + '].wear' 
        : 'winterSeasonInfo.tires[' + tireIndex + '].wear'));
      if (wearIndex > -1) { this.errors.splice(wearIndex, 1); }
      const widthIndex = this.errors.findIndex((error) => error.field === (isSummer 
        ? 'summerSeasonInfo.tires[' + tireIndex + '].width' 
        : 'winterSeasonInfo.tires[' + tireIndex + '].width'));
      if (widthIndex > -1) { this.errors.splice(widthIndex, 1); }
      const irregularWearIndex = this.errors.findIndex((error) => error.field === (isSummer 
        ? 'summerSeasonInfo.tires[' + tireIndex + '].irregularWear' 
        : 'winterSeasonInfo.tires[' + tireIndex + '].irregularWear'));
      if (irregularWearIndex > -1) { this.errors.splice(irregularWearIndex, 1); }
      const crackIndex = this.errors.findIndex((error) => error.field === (isSummer 
        ? 'summerSeasonInfo.tires[' + tireIndex + '].crack' 
        : 'winterSeasonInfo.tires[' + tireIndex + '].crack'));
      if (crackIndex > -1) { this.errors.splice(crackIndex, 1); }
      const scratchDeformationIndex = this.errors.findIndex((error) => error.field === (isSummer 
        ? 'summerSeasonInfo.tires[' + tireIndex + '].scratchDeformation' 
        : 'winterSeasonInfo.tires[' + tireIndex + '].scratchDeformation'));
      if (scratchDeformationIndex > -1) { this.errors.splice(scratchDeformationIndex, 1); }
      const hardnessIndex = this.errors.findIndex((error) => error.field === (isSummer 
        ? 'summerSeasonInfo.tires[' + tireIndex + '].hardness' 
        : 'winterSeasonInfo.tires[' + tireIndex + '].hardness'));
      if (hardnessIndex > -1) { this.errors.splice(hardnessIndex, 1); }
    }
  }

  private setDefaultTireBrand() {
    // Disabled because spec update
    // tireBrandService.findByName('ブリヂストン')
    //   .then((res) => {
    //     if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
    //       this.tireBrandDefaultOption = res.data.data;
    //       // if (this.tireContract.summerSeasonInfo
    //       //   && this.tireContract.summerSeasonInfo.tireBrand
    //       //   && !this.tireContract.summerSeasonInfo.tireBrand.id) {
    //       //   this.tireContract.summerSeasonInfo.tireBrand = res.data.data;
    //       // }
    //       // if (this.tireContract.winterSeasonInfo
    //       //   && this.tireContract.winterSeasonInfo.tireBrand
    //       //   && !this.tireContract.winterSeasonInfo.tireBrand.id) {
    //       //   this.tireContract.winterSeasonInfo.tireBrand = res.data.data;
    //       // }
    //     }
    //   });
  }


  /* Begin tire info */
  private changeTireBrand(isSummer: boolean) {
    let seasonInfo = isSummer ? this.tireContract.summerSeasonInfo : this.tireContract.winterSeasonInfo;
    if (!seasonInfo) {
      return;
    }
    const brand: TireBrand | null | undefined = seasonInfo.tireBrand;
    seasonInfo.tires.forEach((tire) => {
      if (brand) {   
        tire.tireBrand = brand;
      }
    });
  }
  private changeTireSize(isSummer: boolean) {
    let seasonInfo = isSummer ? this.tireContract.summerSeasonInfo : this.tireContract.winterSeasonInfo;
    if (!seasonInfo) {
      return;
    }
    const size: TireSize | null | undefined = seasonInfo.tireSize;
    seasonInfo.tires.forEach((tire) => {
      if (size) {         
        tire.size = size;
      }
    });
  }
  private changeTireWear(isSummer: boolean) {
    let seasonInfo = isSummer ? this.tireContract.summerSeasonInfo : this.tireContract.winterSeasonInfo;
    if (!seasonInfo) {
      return;
    }
    const wear: TireWear | null | undefined = seasonInfo.tireWear;
    seasonInfo.tires.forEach((tire) => {
      if (wear) {         
        tire.wear = wear;
      }
    });
  }
  private changeTireWidth(isSummer: boolean) {
    let seasonInfo = isSummer ? this.tireContract.summerSeasonInfo : this.tireContract.winterSeasonInfo;
    if (!seasonInfo) {
      return;
    }
    const width: TireWidth | null | undefined = seasonInfo.tireWidth;
    seasonInfo.tires.forEach((tire) => {
      if (width) {         
        tire.width = width;
      }
    });
  }
  /* End tire info */

  private changeSummerTirePattern(tirePatternGroup: TirePatternGroup) {
    if (!this.tireContract.summerSeasonInfo || !tirePatternGroup) {
      return;
    }
    this.tireContract.summerSeasonInfo.tirePatternGroup = tirePatternGroup;
    if (tirePatternGroup.listTirePattern) {
      this.tirePatternOptions = tirePatternGroup.listTirePattern;
    } else {
      this.tirePatternOptions = [];
    }
    if (this.tireContract.summerSeasonInfo.tirePattern
      && this.tirePatternOptions
        .map((option) => option.id)
        .indexOf(this.tireContract.summerSeasonInfo.tirePattern.id) === -1) {
      this.tireContract.summerSeasonInfo.tirePattern = new TirePattern();
    }
  }

  private changeWinterTirePattern(tirePatternGroup: TirePatternGroup) {
    if (!this.tireContract.winterSeasonInfo || !tirePatternGroup) {
      return;
    }
    this.tireContract.winterSeasonInfo.tirePatternGroup = tirePatternGroup;
    if (tirePatternGroup.listTirePattern) {
      this.tirePatternOptions = tirePatternGroup.listTirePattern;
    } else {
      this.tirePatternOptions = [];
    }
    if (this.tireContract.winterSeasonInfo.tirePattern
      && this.tirePatternOptions
        .map((option) => option.id)
        .indexOf(this.tireContract.winterSeasonInfo.tirePattern.id) === -1) {
      this.tireContract.winterSeasonInfo.tirePattern = new TirePattern();
    }
  }

  private onInputChange(field: string) {
    const inputError = this.errors.find((e) => e.field === field);
    if (inputError) {
      inputError.isError = undefined;
    }
    if (field === 'period' || field === 'tireType') {
      if (this.tireContract.period === ContractPeriodEnum.SIX_MONTH) {
        // At here, tireType is updated
        this.showTabSummer = this.tireContract.tireType === TireTypeEnum.SUMMER;
        this.showTabWinter = this.tireContract.tireType === TireTypeEnum.WINTER;
      } else {
        this.showTabSummer = true;
        this.showTabWinter = true;
      }
    } else if (field === 'summerSeasonInfo.tireBrand') {
      this.changeTireBrand(true);
    } else if (field === 'summerSeasonInfo.tireSize') {
      this.changeTireSize(true);
    } else if (field === 'summerSeasonInfo.tireWear') {
      this.changeTireWear(true);
    } else if (field === 'summerSeasonInfo.tireWidth') {
      this.changeTireWidth(true);
    } else if (field === 'winterSeasonInfo.tireBrand') {
      this.changeTireBrand(false);
    } else if (field === 'winterSeasonInfo.tireSize') {
      this.changeTireSize(false);
    } else if (field === 'winterSeasonInfo.tireWear') {
      this.changeTireWear(false);
    } else if (field === 'winterSeasonInfo.tireWidth') {
      this.changeTireWidth(false);
    }
  }

  private getInputError(field: string): InputError | undefined {
    const inputError = this.errors.find((e) => e.field === field);   
    return inputError ? inputError : undefined;
  }

  private getPrice(): string {
    // Hide price condition
    if (this.tireContract.period === ContractPeriodEnum.TWELVE_MONTH
        && this.isSwitch) {
      this.tireContract.price = undefined;
      return '';
    }

    if (this.tireContract.period === ContractPeriodEnum.SIX_MONTH) {
      if (this.tireContract.tireType === TireTypeEnum.SUMMER
          && this.tireContract.summerSeasonInfo
          && this.tireContract.summerSeasonInfo.tireWidth) {
        const tireWidth: TireWidth = this.tireContract.summerSeasonInfo.tireWidth;
        // Fee six month
        const feeSixMonth: TireWidthFee | undefined = this.tireFeeList
          .find((feeSixMonth) => feeSixMonth.tireWidthId === tireWidth.id);
        if (feeSixMonth) {        
          let price = Number(feeSixMonth.feeSixMonth); 

          let extendPrice = 0;
          if (this.tireContract.summerSeasonInfo.tires.length === 6) {
            extendPrice = (price * 50 / 100);
          } else if (this.tireContract.summerSeasonInfo.tires.length === 5) {
            extendPrice = (price * 25 / 100);
          }
          this.tireContract.price = price + extendPrice;
          return Math.floor(this.tireContract.price).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        }
      }
      if (this.tireContract.tireType === TireTypeEnum.WINTER
          && this.tireContract.winterSeasonInfo
          && this.tireContract.winterSeasonInfo.tireWidth) {
        const tireWidth: TireWidth = this.tireContract.winterSeasonInfo.tireWidth;
        // Fee six month
        const feeSixMonth: TireWidthFee | undefined = this.tireFeeList
          .find((feeSixMonth) => feeSixMonth.tireWidthId === tireWidth.id);
        if (feeSixMonth) {
          let price = Number(feeSixMonth.feeSixMonth);
          let extendPrice = 0;
          if (this.tireContract.winterSeasonInfo.tires.length === 6) {
            extendPrice = (price * 50 / 100);
          } else if (this.tireContract.winterSeasonInfo.tires.length === 5) {
            extendPrice = (price * 25 / 100);
          }
          this.tireContract.price = price + extendPrice;
          return Math.floor(this.tireContract.price).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        }
      }
    } else {
      if (this.tireContract.summerSeasonInfo
          && this.tireContract.summerSeasonInfo.tireWidth
          && this.tireContract.winterSeasonInfo
          && this.tireContract.winterSeasonInfo.tireWidth) {
        const summerTireWidth: TireWidth = this.tireContract.summerSeasonInfo.tireWidth;
        const winterTireWidth: TireWidth = this.tireContract.winterSeasonInfo.tireWidth;
        const summerFee: TireWidthFee | undefined = this.tireFeeList
          .find((fee) => fee.tireWidthId === summerTireWidth.id);
        const winterFee: TireWidthFee | undefined = this.tireFeeList
          .find((fee) => fee.tireWidthId === winterTireWidth.id);
        if (summerFee && winterFee) {
          let summerPrice = Number(summerFee.fee);
          let winterPrice = Number(winterFee.fee);
          let extendSummerPrice = 0;
          if (this.tireContract.summerSeasonInfo.tires.length === 6) {
            extendSummerPrice = (summerPrice * 50 / 100);
          } else if (this.tireContract.summerSeasonInfo.tires.length === 5) {
            extendSummerPrice = (summerPrice * 25 / 100);
          }
          let extendWinterPrice = 0;
          if (this.tireContract.winterSeasonInfo.tires.length === 6) {
            extendWinterPrice = (winterPrice * 50 / 100);
          } else if (this.tireContract.winterSeasonInfo.tires.length === 5) {
            extendWinterPrice = (winterPrice * 25 / 100);
          }
          const totalSummerPrice = summerPrice + extendSummerPrice;
          const totalWinterPrice = winterPrice + extendWinterPrice;
          this.tireContract.price = (totalSummerPrice > totalWinterPrice) ? totalSummerPrice : totalWinterPrice;
          return Math.floor(this.tireContract.price).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        }       
      }
    }
    return '';
  }

  private confirmInfo(eventName: string) {
    this.errors.forEach((err) => err.isError = undefined);
    // Correct groove from empty string to null
    if (this.tireContract.summerSeasonInfo && this.tireContract.summerSeasonInfo.tires) {
      this.tireContract.summerSeasonInfo.tires.forEach((tire) => {
        if (!tire.groove) {
          tire.groove = null;
        }
      });
    }
    if (this.tireContract.winterSeasonInfo && this.tireContract.winterSeasonInfo.tires) {
      this.tireContract.winterSeasonInfo.tires.forEach((tire) => {
        if (!tire.groove) {
          tire.groove = null;
        }
      });
    }
    
    let contract: TireStoringContract = this.tireContract;
    if (contract.period === ContractPeriodEnum.SIX_MONTH) {
      contract.summerSeasonInfo = contract.tireType === TireTypeEnum.SUMMER ? contract.summerSeasonInfo : undefined;
      contract.winterSeasonInfo = contract.tireType === TireTypeEnum.WINTER ? contract.winterSeasonInfo : undefined;
    }  
    locationService.checkExist({
      shelf1: contract.rackLocation,
      shelf2: contract.columnLocation,
      shelf3: contract.rowLocation
    } as Location
    ).then((res) => {
      if(res.data.data || this.isAgency) {
        tireStoringContractService.validate(contract)
          .then((res) => {
            if (res.data.code === ResponseCodeEnum.CODE_SUCCESS) {
              this.tireContract = contract;
              this.$emit('loadComponent', new DataBus({
                event: eventName,
              }));
            }
          })
          .catch((error) => {
            if (error.response.status === 400) {
              let isError = false;
              this.isSummerTabError = false;
              this.isWinterTabError = false;
              error.response.data.errors.forEach((err: any) => {
                const inputError = this.errors.find((e) => e.field === err.field);          
                if (inputError !== undefined) {
                  isError = true;
                  if (inputError.isError === undefined) {
                    inputError.isError = false;
                    inputError.message = [];
                  }
                  inputError.message.push(err.defaultMessage);
                  if (!this.isSummerTabError && err.field.includes('summerSeasonInfo')) {
                    this.isSummerTabError = true;
                  } 
                  if (!this.isWinterTabError && err.field.includes('winterSeasonInfo')) {
                    this.isWinterTabError = true;
                  } 
                }
              });
              if (isError) {
                window.scrollTo(0, 0);
              }
              if (this.isSummerTabError) {          
                this.activeTabSummer = true;
              } else if (this.isWinterTabError) {
                this.activeTabWinter = true;
              }
              if (!isError) {
                this.$emit('loadComponent', new DataBus({
                  event: eventName,
                }));
              }
              this.loadTireSeasonInfo();
            }
          }); 
      }else {
        toastService.errorMessage('common.message.tire_location_not_exist');
      }
    })
  }

  private saveContract() {
    if (this.isEdit) {
      this.confirmInfo('save_edit');
    }
  }

  private cancelRegister() {
    if (!this.isEdit) {
      this.$emit('loadComponent', new DataBus({
        event: 'cancel_register',
      }));
    }
  }

  private formatNumber(value: string, index: number, isSummer: boolean) {
    if (value && value !== '') {
      let num: number = Number(value);
      if (num) {
        var countDecimals = function (val: number) {
          if(Math.floor(val) === val) return 0;
          return value.toString().split(".")[1].length || 0; 
        }
        var decimal = countDecimals(num);
        let str = '';
        if (decimal >= 0) {
          str = num.toFixed(decimal);
        }
          
        if (num < 1) {
          str = "0." + String(num).split(".")[1];
        }
        if (isSummer) {
          if (this.tireContract.summerSeasonInfo) {
            this.tireContract.summerSeasonInfo.tires[index].groove = str;
          }
        } else {
          if (this.tireContract.winterSeasonInfo) {
            this.tireContract.winterSeasonInfo.tires[index].groove = str;
          }
        }
      } else {
        let err = this.errors.find((error) => error.field === (isSummer 
        ? 'summerSeasonInfo.tires[' + index + '].groove' 
        : 'winterSeasonInfo.tires[' + index + '].groove'));
        if (err) {
          err.isError = false;
        }
      }
    }
  }

  private changeType() {
    this.onInputChange('tireType');
    if (this.tireContract.tireType === TireTypeEnum.SUMMER) {
      this.activeTabSummer = true;
      this.activeTabWinter = false;
    } else {
      this.activeTabWinter = true;
       this.activeTabSummer = false;
    }
  }

  private onKeypressNumber($event: any, length: number) {
		return Utils.keypressNumber($event, length);
  }

  get switchState() {
    if (this.tireContract.slipNo) {
      // Hide when period === 6 months or status is Completed or already switch tire (slipNo end with S)
      const slipNoArray: string[] = this.tireContract.slipNo.split('-');
      if (slipNoArray.length < 3) {
        return false;
      }
      const contractPart: string = slipNoArray[2];
      return (this.tireContract.period !== 0)
                          && (this.tireContract.status !== ContractStatusEnum.COMPLETED)
                          && (contractPart.indexOf('F') > -1)

    }
    return false;
  }

  private cancelSwitchTire() {
    (this.$refs['cancelSwitchTireModal'] as any).show();
  }

  private cancelSwitchFunc() {
    if (this.tireContract.id) {
      const callbackUrl = Utils.getQueryParam(this.$route.query.callbackUrl);
      if (callbackUrl) {
        window.location.href = callbackUrl;
      } else {
        this.$router.push({
          name: 'routes.tire_contract_detail',
          params: {
            id: this.tireContract.id,
          },
        });
      }          
    }
  }
}
